import SpinnerSize from '../enums/spinnerSize';
import SpinnerProps from '../types/components/spinnerProps';
import React from 'react';

const sizes = {
	[SpinnerSize.SMALL]: 'w-[20px] h-[20px] border-[4px] border-t-[4px] ',
	[SpinnerSize.MEDIUM]: 'w-[40px] h-[40px] border-[6px] border-t-[6px]',
	[SpinnerSize.LARGE]: 'w-[60px] h-[60px] border-[8px] border-t-[8px]',
};
const Spinner: React.FC<SpinnerProps> = (props) => {
	const size = props.size || SpinnerSize.SMALL;

	return (
		<div
			className={`loader rounded-full animate-spin border-lightGray border-t-secondary ${sizes[size]}`}
		></div>
	);
};

export default Spinner;
